export default "__VITE_ASSET__3c0049cd__"